/*eslint-disable*/
import { useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import Modal from "react-modal";
import {
  Ban,
  BarChart3,
  ClipboardList,
  Eye,
  FileEdit,
  FileSearch,
  FileText,
  Home,
  MenuIcon,
  MessageCircleQuestion,
  PencilLine,
  RefreshCw,
  ShoppingCart,
  Ticket,
  Users,
} from "lucide-react";
import { Layout, Menu, Typography } from "antd";
Modal.setAppElement("#root");

const { Sider } = Layout;
const { Title, Text } = Typography;

export default function Sidebar({ collapsed, setCollapsed }) {
  const navigate = useNavigate();
  const location = useLocation();
  const userDetails = useRef(JSON.parse(localStorage.getItem("userDetails")));

  const roleObj = {
    agent: "Agent",
    admin: "Admin",
    super_admin: "Super Admin",
    seller_admin: "Seller Admin",
  };

  const menuItems = [
    {
      key: "pages",
      label: "Pages",
      type: "group",
      children: [
        {
          key: "/admin/dashboard",
          icon: <Home size={18} />,
          label: "Dashboard",
        },
        {
          key: "/admin/overview",
          icon: <Eye size={18} />,
          label: "Overview",
        },
        {
          key: "/admin/orders",
          icon: <ShoppingCart size={18} />,
          label: "Customer Orders",
        },
        {
          key: "/admin/invoice",
          icon: <FileText size={18} />,
          label: "Invoice",
        },
        ...(userDetails.current && userDetails.current.role === "super_admin"
          ? [
              {
                key: "/admin/manage-users",
                icon: <Users size={18} />,
                label: "Manage Users",
              },
            ]
          : []),
        {
          key: "/admin/manage-refunds",
          icon: <RefreshCw size={18} />,
          label: "Manage Refunds",
        },
        ...(userDetails.current && userDetails.current.role === "super_admin"
          ? [
              {
                key: "/admin/refund-approve",
                icon: <ClipboardList size={18} />,
                label: "Refund Approvals",
              },
              {
                key: "/admin/hypd-refund-approve",
                icon: <ClipboardList size={18} />,
                label: "Hypd Refund Approvals",
              },
            ]
          : []),
        ...(userDetails.current &&
        (userDetails.current.role === "super_admin" ||
          userDetails.current?.role === "admin" )
          ? [
              {
                key: "/admin/reissue-coupons",
                icon: <Ticket size={18} />, // More relevant icon for coupons
                label: "Reissue Coupons", // Removed hyphen for better grammar
              },
              {
                key: "/admin/crm-tickets",
                icon: <MessageCircleQuestion size={18} />,
                label: "Dabur CRM Tickets",
              },
              {
                key: "/admin/lm-remarks-update",
                icon: <PencilLine size={18} />,
                label: "Lm Remarks Update",
              },
              {
                key: "/admin/po-update",
                icon: <FileEdit size={18} />,
                label: "Po Update",
              },
              {
                key: "/admin/unplaced-order",
                icon: <Ban size={18} />,
                label: "Order Not Placed Refund",
              },
            ]
          : []),
        ...(userDetails.current && userDetails.current?.email === 'crm_dshop2@technobubble.co.in'
          ? [
              {
                key: "/admin/crm-tickets",
                icon: <MessageCircleQuestion size={18} />,
                label: "Dabur CRM Tickets",
              },
            ]
          : []),
           ...(userDetails.current && userDetails.current.role === "super_admin"
          ? [
              {
                key: "/admin/refund-detail-update",
                icon: <FileSearch size={18} />,
                label: "Refund Detail Update",
              },
            ]
          : []),

        {
          key: "/admin/pro-active-reachout",
          icon: <Users size={18} />,
          label: "Pro Active Reachout",
        },
      ],
    },
    {
      key: "reports",
      label: "Reports",
      type: "group",
      children: [
        {
          key: "/admin/sales-report",
          icon: <BarChart3 size={18} />,
          label: "Sales Report",
        },
        {
          key: "/admin/refund-report",
          icon: <RefreshCw size={18} />,
          label: "Refund Report",
        },
      ],
    },
  ];

  const handleMenuClick = ({ key }) => {
    navigate(key);
  };

  return (
    <>
      <Sider
        trigger={null}
        collapsible
        collapsed={collapsed}
        width={280}
        className={`
    fixed left-0 top-0 bottom-0 z-[100]
    bg-white/95 backdrop-blur-xl border-r border-white/20 shadow-[4px_0_24px_rgba(0,0,0,0.1)]
  `}
      >
        {/* Top fixed section: Icon + Branch info */}
        <div className="pt-[18px] pb-0 px-4">
          <div
            className={`flex items-center w-full ${
              collapsed ? "justify-center" : "justify-start"
            }`}
          >
            <div className="w-full flex flex-col">
              <div
                className={`flex w-full items-center mb-2 md:mb-0 ${
                  collapsed ? "justify-center" : "ml-1"
                }`}
              >
                <MenuIcon
                  onClick={() => setCollapsed(!collapsed)}
                  size={20}
                  className="cursor-pointer text-gray-700"
                />
              </div>

              {!collapsed && (
                <div className="flex w-full items-center mb-2 mt-2 border-b border-t pb-2 pt-2">
                  <div
                    className={`
                w-8 h-8 bg-gradient-to-br from-[#619269] to-[#4a7c59]
                rounded-md flex items-center justify-center mr-3
              `}
                  >
                    <BarChart3 size={18} color="white" />
                  </div>
                  <div>
                    <h4 className="text-sm font-semibold text-[#262626] m-0">
                      Dabur Stellar
                    </h4>
                    <p className="text-xs text-[#8c8c8c]">
                      {roleObj[localStorage?.role] || ""}
                    </p>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>

        {/* Scrollable menu section */}
        <div className="overflow-auto h-[calc(100vh-100px)] px-4 pb-6">
          <Menu
            mode="inline"
            selectedKeys={[location.pathname]}
            items={menuItems}
            onClick={handleMenuClick}
            style={{
              border: "none",
              background: "transparent",
            }}
          />
        </div>
      </Sider>
    </>
  );
}
